import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

interface NavigationDaysProps {
  numOfDays: number;
}

interface DayLink {
  path: string;
  dayNumber: number;
  label: string;
}

export const NavigationDays: React.FC<NavigationDaysProps> = ({
  numOfDays,
}) => {
  const location = useLocation();

  const dayLinks: DayLink[] = Array.from({ length: numOfDays }, (_, i) => {
    const dayNumber = i + 1;
    return {
      path: `${location.pathname}/${dayNumber}`,
      dayNumber,
      label: `День ${dayNumber}`,
    };
  });

  const activeKey =
    dayLinks.find((day) => location.pathname.startsWith(day.path))?.path || '';

  return (
    <Nav 
      variant="pills" 
      activeKey={activeKey}
      role="navigation"
      aria-label="Навігація по дням"
      style={{ marginBottom: '1.5rem' }}
    >
      {dayLinks.map((day) => (
        <Nav.Item key={day.path}>
          <Nav.Link 
            as={Link} 
            to={day.path} 
            eventKey={day.path}
            aria-current={activeKey === day.path ? 'page' : undefined}
            aria-label={`Перейти до ${day.label}`}
          >
            {day.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
